import React from "react";

export const YhSourceIcon = ({ source }: { source: string }) => {
  const key = String(source || "")
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

  const wrap = (bg: string, children: React.ReactNode) => (
    <span
      className="flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-lg text-white"
      style={{ backgroundColor: bg }}
    >
      {children}
    </span>
  );

  if (key.includes("facebook") || key === "fb") {
    return wrap(
      "#1877F2",
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M14 8h3V4h-3c-2.8 0-5 2.2-5 5v2H6v4h3v8h4v-8h3.1l.9-4H13V9c0-.6.4-1 1-1z" />
      </svg>
    );
  }

  if (
    key.includes("99acre") ||
    key.includes("99acres") ||
    key === "acres" ||
    key === "acre"
  ) {
    return wrap(
      "#1A73E8",
      <span className="flex flex-col items-center leading-none">
        <span className="text-[9px] font-extrabold tracking-tight">99</span>
        <span className="text-[6px] font-semibold tracking-tight">acres</span>
      </span>
    );
  }

  if (key.includes("website") || key.includes("www") || key === "web") {
    return wrap(
      "#0EA5E9",
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a15 15 0 010 18M12 3a15 15 0 000 18" />
      </svg>
    );
  }

  if (key.includes("instagram") || key === "ig") {
    return wrap(
      "#E4405F",
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
      </svg>
    );
  }

  if (key.includes("whatsapp") || key === "wa") {
    return wrap(
      "#25D366",
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M12 2a10 10 0 00-8.7 14.9L2 22l5.3-1.4A10 10 0 1012 2zm5.6 14.2c-.2.7-1.3 1.2-2.1 1.4-.5.1-1.2.2-3.5-.7-2.9-1.2-4.7-4.1-4.9-4.3-.2-.2-1.5-2-1.5-3.8s1-2.7 1.3-3.1c.3-.3.7-.4 1-.4h.7c.2 0 .5 0 .7.6l1 2.4c.1.2.1.4 0 .6l-.4.7c-.1.2-.3.4-.1.7.2.3.7 1.1 1.5 1.8 1 .9 1.9 1.2 2.2 1.3.3.1.5.1.7-.1l.9-1.1c.2-.2.4-.2.6-.1l2.2 1c.2.1.4.2.5.3.1.2.1.8-.1 1.5z" />
      </svg>
    );
  }

  if (key.includes("google") || key.includes("gads") || key.includes("gclid")) {
    return wrap(
      "#EA4335",
      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M22.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.4h5.9c-.3 1.4-1.1 2.6-2.3 3.4v2.8h3.7c2.2-2 3.4-5 3.4-8.3z" fill="#4285F4" />
        <path d="M12 23c3.1 0 5.7-1 7.6-2.8l-3.7-2.8c-1 .7-2.4 1.1-3.9 1.1-3 0-5.5-2-6.4-4.7H1.8v2.9C3.7 20.5 7.5 23 12 23z" fill="#34A853" />
        <path d="M5.6 13.8c-.2-.7-.4-1.4-.4-2.2s.1-1.5.4-2.2V6.5H1.8A11 11 0 001 11.6c0 1.8.4 3.4 1.1 4.9l3.5-2.7z" fill="#FBBC05" />
        <path d="M12 5.4c1.7 0 3.2.6 4.4 1.7l3.3-3.3C18.7 1.9 15.6.7 12 .7 7.5.7 3.7 3.2 1.8 6.5l3.8 2.9C6.5 7.4 9 5.4 12 5.4z" fill="#EA4335" />
      </svg>
    );
  }

  if (key.includes("magicbrick")) {
    return wrap(
      "#E11D48",
      <span className="text-[8px] font-extrabold leading-none">MB</span>
    );
  }

  if (key.includes("housing")) {
    return wrap(
      "#A02448",
      <span className="text-[8px] font-extrabold leading-none">H</span>
    );
  }

  // Fallback: letter avatar
  const initial = String(source).trim().charAt(0).toUpperCase() || "?";
  const colors = ["#A02448", "#3B82F6", "#14B8A6", "#F59E0B", "#EF4444", "#1E3A8A"];
  let hash = 0;
  for (let i = 0; i < String(source).length; i++) {
    hash = String(source).charCodeAt(i) + ((hash << 5) - hash);
  }
  return wrap(colors[Math.abs(hash) % colors.length], (
    <span className="text-xs font-bold">{initial}</span>
  ));
};

export const SourceBrandIcon = YhSourceIcon;
export default YhSourceIcon;
